import Mock from 'mockjs'

Mock.setup({
  timeout: '350-600'
})



// WEBPACK FOOTER //
// ./src/data/mock/index.js